import { GlossaryEntriesProps } from './GlossaryProps';

const formatArrayToStringForCsv = (objArray: object) => {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
  const str =
    `${Object.keys(array[0])
      .map((value) => `"${value}"`)
      .join(',')}` + '\r\n';

  return array.reduce((str: string, next: object) => {
    str +=
      `${Object.values(next)
        .map((value) => `"${value}"`)
        .join(',')}` + '\r\n';
    return str;
  }, str);
};

export const generateCsv = (metricData: object) => {
  const fields = Object.keys(metricData).map((name) => ({
    Metric: name,
    Definition: metricData[name].definition,
    Methodology: metricData[name].methodology?.replace(/<[^>]+>/g, '') || '',
    Source: metricData[name].source?.replace(/<[^>]+>/g, '') || ''
  }));
  const csvFields = formatArrayToStringForCsv(fields);
  const element = document.createElement('a');
  element.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvFields);
  element.target = '_blank';
  element.download = 'glossary_export.csv';
  element.click();
};

export const getAvailableLetters = (
  entries: GlossaryEntriesProps
): string[] => {
  return Object.keys(entries).reduce((letters: string[], entry) => {
    if (!letters.includes(entry[0])) letters.push(entry[0]);
    return letters;
  }, []);
};

export const search = ({
  term,
  entries,
  fullTextSearch = false
}: {
  term: string;
  entries: GlossaryEntriesProps;
  fullTextSearch?: boolean;
}): string[] => {
  return Object.keys(entries).filter((entry) => {
    const cleanedEntry = entry.toLowerCase();
    if (!fullTextSearch) return cleanedEntry.includes(term);
    const entryObj = entries[entry];
    const entryInText = entryObj.definition.toLowerCase().includes(term);
    return cleanedEntry.includes(term) || entryInText;
  });
};
